<template>
  <div class="pbc-z-level-1 topnav fixed top-0 left-0 right-0 h-10">
    <div class="pt-1 w-full flex flex-row justify-between mb-2">
      <div class="self-start ml-5 my-auto mr-3 spinner text-white" />
        <div class="self-center text-xl text-white self-center">Loading Posts...</div>
        <div class="self-end flex flex-row">
          <img class="w-6 h-6 my-auto ml-1 mr-0" src='/img/PBC_logo.svg' />
        </div>
      </div>
    </div>


</template>
<script>
export default {
}
</script>
